const MONTH_NAMES = [
  'Ocak',
  'Şubat',
  'Mart',
  'Nisan',
  'Mayıs',
  'Haziran',
  'Temmuz',
  'Ağustos',
  'Eylül',
  'Ekim',
  'Kasım',
  'Aralık',
];

const MONTH_INDEX: Record<string, number> = MONTH_NAMES.reduce(
  (acc, m, i) => ({ ...acc, [m]: i }),
  {} as Record<string, number>,
);

export function parseTrDate(tr: string): Date {
  const parts = tr.split(' ');
  const day = parseInt(parts[0], 10);
  const month = MONTH_INDEX[parts[1]];
  const year = parseInt(parts[2], 10);
  return new Date(year, month, day);
}

export function toTrDate(d: Date): string {
  return `${d.getDate()} ${MONTH_NAMES[d.getMonth()]} ${d.getFullYear()}`;
}

export function dayOfWeek(tr: string): string {
  const days = ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'];
  return days[parseTrDate(tr).getDay()];
}

export function weekdayLabel(d: Date): string {
  const days = ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar'];
  return days[d.getDay()];
}